import { createAction, props } from '@ngrx/store';
import { OrderFilters } from '@shared/models/order-filters';
import { PaginationState } from '@shared/models/pagination-state';

export const downloadRenewalsCsv = createAction('[Renewals] Download Renewals CSV', props<{ filters: OrderFilters }>());

export const downloadRenewalsCsvSuccess = createAction(
  '[Renewals] Download Renewals CSV Success',
  props<{ data: any }>(),
);

export const downloadRenewalsCsvFailure = createAction(
  '[Renewals] Download Renewals CSV Failure',
  props<{ error: any }>(),
);

export const updateRenewalsCsvProgress = createAction(
  '[Renewals] Update Renewals CSV Progress',
  props<{ paginationState: PaginationState }>(),
);
